import React, { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

interface Props {
  children: any;
}

interface ToastContextData {
  type: "success" | "info" | "warning" | "error";
  title: string;
  message?: string;
  noTranslateMessage?: boolean;
  callback?: () => void;
}

export interface IToastContext {
  openToast: (data: ToastContextData) => void;
}

export const ToastContext = React.createContext<IToastContext>({
  openToast: () => {},
});

export const ToastContextProvider = ({ children }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const openToast = (data: ToastContextData): void => {
    toast(() => renderToast(data), {
      type: data.type,
      onClose: () => {
        if (data.callback) {
          data.callback();
        }
      },
    });
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  const renderToast = (data: ToastContextData): React.ReactNode => {
    return (
      <div>
        <span className="title">{t(data.title)}</span>
        <span className="message">
          {/* if translate */}
          {!data.noTranslateMessage &&
            t(!!data.message ? data.message : "errors.general.description")}

          {/* if no translate */}
          {!!data.noTranslateMessage && data.message}
        </span>
      </div>
    );
  };

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[Toast provider] init");
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[Toast provider] destroy");
    // destroy all
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <ToastContext.Provider
      value={{
        openToast,
      }}
    >
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};
